import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { useFormDisable } from './form'
import { FormatLabel } from './format-label'
import { useFormDefaultNull, useFormDefaultValue, useGetWatchValue } from './hooks/input-hooks'

// caseSensitive: the typed value must equal confirmValue exactly (after
// trimming), as the server checks it -- e.g. typing an organization's name to
// delete it. Off by default: "Type purge to confirm" ignores case.
export const confirmMatches = (value, confirmValue, caseSensitive) => {
  const typed = String(value || '').trim()
  const want = String(confirmValue || '')
  return caseSensitive ? typed === want.trim() : typed.toLowerCase() === want.toLowerCase()
}

export const FormTextConfirm = ({ label, placeholder, subtext, name, required, defaultValue, confirmValue, caseSensitive, shouldDirty, autoFocus }) => {
  const { register, setError, clearErrors } = useFormContext()

  const formDisabled = useFormDisable()

  let watchValue = useGetWatchValue(name)

  useEffect(
    () => {
      if (required && !watchValue) {
        setError(name, { message: 'required' })
      } else if (!confirmMatches(watchValue, confirmValue, caseSensitive)) {
        setError(name, { message: 'mismatch' })
      } else {
        clearErrors(name)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [watchValue, confirmValue, caseSensitive]
  )

  useFormDefaultNull(name)
  useFormDefaultValue(name, defaultValue, shouldDirty)

  return (
    <React.Fragment>
      <FormatLabel name={name} label={label} subtext={subtext} hasValue={!!watchValue} required={required}>
        <input className="form-control" placeholder={placeholder} autoFocus={autoFocus} type="text" {...register(name, { required })} disabled={formDisabled} />
      </FormatLabel>
    </React.Fragment>
  )
}
